@if (isLoading) {
  <div >
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
    <h5>Retrieving data...</h5>
  </div>
}


<!-- Load VideoList and VideoViewer -->
@if (!isLoading) {
  <div>
    <div class="content-area">
      <!-- Conditionally display VideoListComponent and VideoPlayerComponent -->
      @if (!selectedVideo) {
        <app-videolist
          [videos]="videos"
          [isLoggedIn]="(auth.loggedIn$ | async) ?? false"
          (videoSelected)="onVideoSelected($event)">
        </app-videolist>
      } @else {
        <app-videoviewer
          [videoUrl]="selectedVideo!.videoUrl"
          [videoCODE]="selectedVideo!.item_CODE"
          [videoTitle]="selectedVideo!.title"
          (back)="backToList()">
        </app-videoviewer>
      }
      <!-- Template for Video Player Component -->
    </div>
  </div>
}